import { Route, Switch } from "wouter";
import ConnectionEditorPage from "@/pages/connections/editor";
import ConnectionsListPage from "@/pages/connections/list";
import ConnectionSetupPage from "@/pages/connections/setup";
import { editorKeyFor, newEditorKey } from "@/lib/connectionEditorKey";
import NotFoundPage from "@/pages/not-found";

/**
 * Connections (UX-3, FR-4x).
 *
 * `App.tsx` mounts this route with wouter's `nest`, so the paths below are
 * relative to `/connections` and the editor lives INSIDE the section rather
 * than beside it. That is what keeps the nav rail on Connections and the page
 * header reading "Connections" while a single connection is open — `routeFor`
 * resolves a nested path to its longest declared prefix — and it means opening
 * the editor needs no second entry in `APP_ROUTES`, which is the table the nav
 * drawer renders.
 */
export default function ConnectionsPage() {
  return (
    <Switch>
      <Route path="/" component={ConnectionsListPage} />
      {/* Each editor is keyed by the record it edits (#1647, the pattern of schedules.tsx): `/new`
          and `/:id` render the same component in the same place, so without a key React kept the
          last connection's validation, counts and stale warning when the person went to New. A create
          keeps its own editor for the new id (`keepEditorForCreated`), so the post-save state stays. */}
      <Route path="/new">
        <ConnectionEditorPage key={newEditorKey()} />
      </Route>
      {/* Release 8B (ADR 0009 section 7): a draft an AI app created; the person types its
          credentials here, in skyData, runs Connect and saves. */}
      <Route path="/:id/setup">
        {(params) => <ConnectionSetupPage id={params.id as string} />}
      </Route>
      <Route path="/:id">
        {(params) => <ConnectionEditorPage key={editorKeyFor(params.id as string)} />}
      </Route>
      <Route component={NotFoundPage} />
    </Switch>
  );
}
